import React from 'react';
import { Box } from '@mui/material';

const VideoViewer = ({ videofile, width = '100%' }) => {
  const src = videofile.surl || videofile.url || videofile.cdn_url || videofile.turl;

  return (
    <Box sx={{ width: '100%', maxWidth: width, margin: '0 auto' }}>
      <video
        controls
        style={{ width: '600px', maxWidth: '100%', borderRadius: 8, background: '#000' }}
        src={src}
      >
        Your browser does not support the video tag.
      </video>
    </Box>
  );
};

export default VideoViewer;